module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuODY3IiBoZWlnaHQ9IjUzNy4xNTIiIHZpZXdCb3g9IjAgMCA0NzAuODY3IDUzNy4xNTIiPgogIDxwYXRoIGlkPSLjg5HjgrlfMzc0OSIgZGF0YS1uYW1lPSLjg5HjgrkgMzc0OSIgZD0iTTUxNy4yMzIsMTQwNi42OVYxMDQ4TDk4OC4xLDg2OS41MzZ2MzU4LjY4OVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01MTcuMjMxIC04NjkuNTM3KSIgZmlsbD0iYmx1ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/blue_471.svg
// module id = N0/n
// module chunks = 0